import consumer from "./consumer"

// Turbo fires turbo:load on the first page load as well as after every visit,
// so it is the only event listened to. The channel used to subscribe on
// DOMContentLoaded (init()) and again on every turbo:load (init(true), which
// skipped the "already initialized" guard), never unsubscribing: a full load
// opened two CemantixChannel subscriptions and every visit added one more.
// Action Cable hands a broadcast to every local subscription sharing the
// identifier, so each "new player" flash was shown, and each "new_word"
// event dispatched, once per subscription. init() is now idempotent per
// element, which is all the force flag was working around.
document.addEventListener('turbo:load', () => {
  window.site.cemantix.init();
});

// The page is about to be cached and left: its subscriptions go with it, and
// the next visit (or the restored snapshot's turbo:load) opens fresh ones.
// The Cémantix page itself is `turbo-cache-control: no-cache`, so this rarely
// fires for it; the next turbo:load closes the subscriptions whose element is
// gone instead.
document.addEventListener('turbo:before-cache', () => {
  window.site.cemantix.unsubscribeAll();
});

window.site = {
  ...window.site || {},
  cemantix: {
    subscriptions: new Map(),
    init() {
      // Subscriptions whose element left the page, by game. A visit to the
      // same game (the page a guest lands on after "Rejoindre") keeps its
      // subscription rather than closing it and opening an identical one:
      // the server runs both commands at once, and a subscription arriving
      // while the one it replaces is still being closed is dropped
      // silently, which left the guest out of the game.
      const detached = new Map();
      window.site.cemantix.subscriptions.forEach((subscription, element) => {
        if (element.isConnected) return;

        detached.set(element.dataset.cemantixId, subscription);
        window.site.cemantix.subscriptions.delete(element);
      });

      document.querySelectorAll('[data-channel-subscribe="cemantix"]').forEach(element => {
        if (window.site.cemantix.subscriptions.has(element)) return;

        const cemantix_id = element.dataset.cemantixId;
        const kept = detached.get(cemantix_id);

        if (kept) {
          kept.page.element = element;
          detached.delete(cemantix_id);
          window.site.cemantix.subscriptions.set(element, kept);
          return;
        }

        // The element the subscription serves, moved along when it is kept.
        const page = { element };
        const subscription = consumer.subscriptions.create({ channel: "CemantixChannel", cemantix_id: cemantix_id }, {
          received: function(data) {
            // A broadcast for a game no longer on the page.
            if (!page.element.isConnected) return;

            // Looked up when the event arrives, not when subscribing: the
            // counter belongs to the page being shown.
            const counter = document.querySelector('.js-cemantix-team-counter');
            const fromSomeoneElse = !window.gon || !window.gon.users || window.gon.users.id != data.user.id;

            switch(data.event) {
              case "new_player":
                if (fromSomeoneElse) {
                  FLASH.success(`<strong class="font-bold">${data.user.name}</strong> vient de rejoindre la partie`);
                }

                if (counter) {
                  if (data.players.length > 1) counter.classList.remove('hidden');
                  counter.innerHTML = data.players.length;
                }
                break;
              case "player_disconnected":
                if (fromSomeoneElse) {
                  FLASH.alert(`<strong class="font-bold">${data.user.name}</strong> vient de quitter la partie`);
                }

                if (counter) {
                  if (data.players.length < 2) counter.classList.add('hidden');
                  counter.innerHTML = data.players.length;
                }
                break;
              case "new_word":
                // On window, where the Cemantix component listens: a
                // non-bubbling event dispatched on document never reached it,
                // so a teammate's words were never shown.
                window.dispatchEvent(
                  new CustomEvent('new_word', { detail: data })
                );
                break;
              default:
                return;
            }

            window.mountComponents(window.components);
          }
        });

        subscription.page = page;
        window.site.cemantix.subscriptions.set(element, subscription);
      });

      // Games no longer shown at all.
      detached.forEach(subscription => subscription.unsubscribe());
    },
    unsubscribeAll() {
      window.site.cemantix.subscriptions.forEach(subscription => subscription.unsubscribe());
      window.site.cemantix.subscriptions.clear();
    }
  }
}
